export default function formatDate(
    date: Date,
    options?: Intl.DateTimeFormatOptions,
) {
    return date.toLocaleDateString(
        'en-za',
        options || {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
        },
    );
}
